import service from "../util/http";

// 质量反馈单删除
export const deleteEmptyFormApi = (questionId) => {
  return service({
    url: "/customer/kd/feedback/deleteEmptyForm?feedbackFormId=" + questionId,
    method: "post",
  })
}

// 质量反馈KD列表
export const feedbackListApi = (data) => {
  return service({
    url: "/customer/kd/feedback/list",
    method: "post",
    data,
  });
};

// 质量反馈KD问题列表
export const questionListApi = (data) => {
  return service({
    url: "/customer/kd/feedback/questionList",
    method: "post",
    data,
  });
};

// 质量反馈KD问题新增
export const problemAddApi = (data) => {
  return service({
    url: "/customer/kd/feedback/add",
    method: "post",
    data,
  });
};

// 质量反馈KD问题删除
export const problemDeleteApi = (data) => {
  return service({
    url: "/customer/kd/feedback/removeQuestion",
    method: "post",
    data,
  });
};

// 质量反馈KD问题编辑
export const problemEditApi = (data) => {
  return service({
    url: "/customer/kd/feedback/edit",
    method: "post",
    data,
  });
};

// 质量反馈KD提交
export const feedbackSubmitApi = (data) => {
  return service({
    url: "/customer/kd/feedback/submit",
    method: "post",
    data,
  });
};

// 审核
export const auditProblem = (data) => {
  return service({
    url: "/customer/kd/feedback/audit",
    method: "post",
    data,
  });
};

// 审核记录
export const kdAuditHistoryList = (data) => {
  return service({
    url: "/customer/kd/feedback/auditHistoryList",
    method: "post",
    data,
  });
};
// 审核临时措施驳回通过
export const dealerAuditKDApi = data => {
  return service({
    url: "/customer/kd/feedback/kdDealerAudit",
    method: "post",
    data
  });
};

